import React, { useState, useEffect, useContext, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { Collapse } from 'antd';

const ConfidenceIntervalsChart = (props) => {
    const { Panel } = Collapse;

    const avgD = props.getAnalysisRes.confidence_intervals.chart.avg_interval;
    const iqrD = props.getAnalysisRes.confidence_intervals.chart.iqr_interval;
    const nchD =
        props.getAnalysisRes.confidence_intervals.chart.notches_interval;

    let confidenceIntervalsSeries = [];

    if (avgD.hasOwnProperty('0.5')) {
        confidenceIntervalsSeries.push({
            lineWidth: 2,
            color: '#198ec4',
            name: 'Average Interval conf. level 50%',
            data: [
                [parseFloat(avgD[0.5][0].toFixed(3)), 0.5],
                [parseFloat(avgD[0.5][1].toFixed(3)), 0.5],
                [parseFloat(avgD[0.5][2].toFixed(3)), 0.5]
            ],
            marker: { symbol: 'circle' }
        });
    }
    if (avgD.hasOwnProperty('0.68')) {
        confidenceIntervalsSeries.push({
            lineWidth: 2,
            color: '#198ec4',
            name: 'Average Interval conf. level 68%',
            data: [
                [parseFloat(avgD[0.68][0].toFixed(3)), 1],
                [parseFloat(avgD[0.68][1].toFixed(3)), 1],
                [parseFloat(avgD[0.68][2].toFixed(3)), 1]
            ],
            marker: { symbol: 'circle' }
        });
    }
    if (avgD.hasOwnProperty('0.9')) {
        confidenceIntervalsSeries.push({
            lineWidth: 2,
            color: '#198ec4',
            name: 'Average Interval conf. level 90%',
            data: [
                [parseFloat(avgD[0.9][0].toFixed(3)), 1.5],
                [parseFloat(avgD[0.9][1].toFixed(3)), 1.5],
                [parseFloat(avgD[0.9][2].toFixed(3)), 1.5]
            ],
            marker: { symbol: 'circle' }
        });
    }
    if (avgD.hasOwnProperty('0.95')) {
        confidenceIntervalsSeries.push({
            lineWidth: 2,
            color: '#198ec4',
            name: 'Average Interval conf. level 95%',
            data: [
                [parseFloat(avgD[0.95][0].toFixed(3)), 2],
                [parseFloat(avgD[0.95][1].toFixed(3)), 2],
                [parseFloat(avgD[0.95][2].toFixed(3)), 2]
            ],
            marker: { symbol: 'circle' }
        });
    }
    confidenceIntervalsSeries.push(
        {
            lineWidth: 2,
            color: '#60091d',
            name: 'Notches Interval',
            data: [
                [parseFloat(nchD[0].toFixed(3)), 2.5],
                [parseFloat(nchD[1].toFixed(3)), 2.5],
                [parseFloat(nchD[2].toFixed(3)), 2.5]
            ],
            marker: { symbol: 'circle' }
        },
        {
            lineWidth: 2,
            color: '#5d9d35',
            name: 'IQR Interval',
            data: [
                [parseFloat(iqrD[0].toFixed(3)), 3],
                [parseFloat(iqrD[1].toFixed(3)), 3],
                [parseFloat(iqrD[2].toFixed(3)), 3]
            ],
            marker: { symbol: 'circle' }
        }
    );

    let confidenceIntervalsOptions = {
        chart: {
            type: 'scatter',
            marginRight: 30,
            marginLeft: 80,
            marginBottom: 35,
            marginTop: 30,
            plotBorderWidth: 1,
            height: '280',
            zoomType: 'xy'
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true
        },
        credits: {
            enabled: false,
            text: 'Copyright 2022 RoyaltyStat',
            href: '//www.royaltystat.com'
        },
        title: { text: '' },

        exporting: {
            chartOptions: {
                title: {
                    text: ''
                }
            }
        },
        navigation: {
            buttonOptions: {
                y: -10
            }
        },
        labels: {
            items: [
                {
                    html: 'IQR',
                    style: {
                        position: 'absolute',
                        left: '-70px',
                        // top: '99px',
                        top: '28px',
                        fontSize: '11px'
                    }
                },
                {
                    html: 'Notches',
                    style: {
                        position: 'absolute',
                        left: '-70px',
                        top: '63px',
                        fontSize: '11px'
                    }
                },
                {
                    html: 'Average',
                    style: {
                        position: 'absolute',
                        left: '-70px',
                        top: '135px',
                        fontSize: '11px'
                    }
                }
            ]
        },
        xAxis: {
            gridLineWidth: 0,
            minPadding: 0.1,
            maxPadding: 0.1,
            endOnTick: false,
            labels: {
                formatter: function () {
                    return this.value;
                },
                style: { fontSize: '9px' }
            }
        },
        yAxis: {
            gridLineWidth: 0,
            title: { text: ' ', margin: 60 },
            labels: { enabled: false },
            max: 3.5,
            endOnTick: false
        },
        legend: { enabled: false },
        plotOptions: {
            series: { shadow: false },
            scatter: {
                shadow: false,
                marker: { enabled: true, radius: 3 }
            }
        },
        tooltip: {
            formatter: function () {
                let pointName = 'Median';
                if (this.series.name == 'Confidence Interval for Average') {
                    pointName = 'Average';
                }

                let toolTipMsg =
                    this.series.name + '<br> ' + pointName + ': ' + this.x;

                if (this.point.index == 0) {
                    pointName = 'Lower';
                } else if (this.point.index == 2) {
                    pointName = 'Upper';
                }

                return this.series.name + '<br> ' + pointName + ':' + this.x;
            }
        },
        series: confidenceIntervalsSeries
        // series: [
        //     {
        //         lineWidth: 2,
        //         color: '#198ec4',
        //         name: 'Average Interval conf. level 50%',
        //         data: [
        //             [parseFloat(avgD[0.5][0].toFixed(3)), 0.5],
        //             [parseFloat(avgD[0.5][1].toFixed(3)), 0.5],
        //             [parseFloat(avgD[0.5][2].toFixed(3)), 0.5]
        //         ],
        //         marker: { symbol: 'circle' }
        //     },
        //     {
        //         lineWidth: 2,
        //         color: '#198ec4',
        //         name: 'Average Interval conf. level 68%',
        //         data: [
        //             [parseFloat(avgD[0.68][0].toFixed(3)), 1],
        //             [parseFloat(avgD[0.68][1].toFixed(3)), 1],
        //             [parseFloat(avgD[0.68][2].toFixed(3)), 1]
        //         ],
        //         marker: { symbol: 'circle' }
        //     },
        //     {
        //         lineWidth: 2,
        //         color: '#198ec4',
        //         name: 'Average Interval conf. level 90%',
        //         data: [
        //             [parseFloat(avgD[0.9][0].toFixed(3)), 1.5],
        //             [parseFloat(avgD[0.9][1].toFixed(3)), 1.5],
        //             [parseFloat(avgD[0.9][2].toFixed(3)), 1.5]
        //         ],
        //         marker: { symbol: 'circle' }
        //     },
        //     {
        //         lineWidth: 2,
        //         color: '#198ec4',
        //         name: 'Average Interval conf. level 95%',
        //         data: [
        //             [parseFloat(avgD[0.95][0].toFixed(3)), 2],
        //             [parseFloat(avgD[0.95][1].toFixed(3)), 2],
        //             [parseFloat(avgD[0.95][2].toFixed(3)), 2]
        //         ],
        //         marker: { symbol: 'circle' }
        //     },

        //     {
        //         lineWidth: 2,
        //         color: '#60091d',
        //         name: 'Notches Interval',
        //         data: [
        //             [parseFloat(nchD[0].toFixed(3)), 2.5],
        //             [parseFloat(nchD[1].toFixed(3)), 2.5],
        //             [parseFloat(nchD[2].toFixed(3)), 2.5]
        //         ],
        //         marker: { symbol: 'circle' }
        //     },
        //     {
        //         lineWidth: 2,
        //         color: '#5d9d35',
        //         name: 'IQR Interval',
        //         data: [
        //             [parseFloat(iqrD[0].toFixed(3)), 3],
        //             [parseFloat(iqrD[1].toFixed(3)), 3],
        //             [parseFloat(iqrD[2].toFixed(3)), 3]
        //         ],
        //         marker: { symbol: 'circle' }
        //     }
        // ]
    };

    //  TABLES

    let confidenceIntervalsTable =
        props.getAnalysisRes.confidence_intervals.statistics;

    // let regHeaders = [];
    let confidenceIntervalsRows = [];

    for (let i = 0; i < Object.keys(confidenceIntervalsTable).length; i++) {
        // console.log(Object.keys(data)[i])
        confidenceIntervalsRows.push(
            Object.values(confidenceIntervalsTable)[i]
        );
    }

    // let newConfidenceIntervalsRows = Object.keys(confidenceIntervalsTable).map(
    //     (key) => {
    //         let item = confidenceIntervalsTable[key];
    //         let fixedValue = item.value;

    //         let cI = [
    //             'crit_t_stat',
    //             'avg_interval_lower',
    //             'avg_interval_upper'
    //         ];

    //         return (
    //             <>
    //                 {cI.includes(key) ? (
    //                     <>
    //                         <Col
    //                             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                             style={{ marginTop: 10 }}
    //                         >
    //                             <Card>
    //                                 <Statistic
    //                                     key={item.display_name}
    //                                     title={item.display_name + ' 50%'}
    //                                     value={fixedValue[0]}
    //                                 />
    //                             </Card>
    //                         </Col>
    //                         <Col
    //                             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                             style={{ marginTop: 10 }}
    //                         >
    //                             <Card>
    //                                 <Statistic
    //                                     key={item.display_name}
    //                                     title={item.display_name + ' 68%'}
    //                                     value={fixedValue[1]}
    //                                 />
    //                             </Card>
    //                         </Col>
    //                         <Col
    //                             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                             style={{ marginTop: 10 }}
    //                         >
    //                             <Card>
    //                                 <Statistic
    //                                     key={item.display_name}
    //                                     title={item.display_name + ' 90%'}
    //                                     value={fixedValue[2]}
    //                                 />
    //                             </Card>
    //                         </Col>
    //                         <Col
    //                             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                             style={{ marginTop: 10 }}
    //                         >
    //                             <Card>
    //                                 <Statistic
    //                                     key={item.display_name}
    //                                     title={item.display_name + ' 95%'}
    //                                     value={fixedValue[3]}
    //                                 />
    //                             </Card>
    //                         </Col>
    //                     </>
    //                 ) : (
    //                     <Col
    //                         span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                         style={{ marginTop: 10 }}
    //                     >
    //                         <Card>
    //                             <Statistic
    //                                 key={item.display_name}
    //                                 title={item.display_name}
    //                                 value={fixedValue}
    //                             />
    //                         </Card>
    //                     </Col>
    //                 )}
    //             </>
    //         );
    //     }
    // );

    // let statConfidenceIntervalsTable = (
    //     <>
    //         <div>
    //             <Row className="statistics-row-box" gutter={16}>
    //                 {newConfidenceIntervalsRows}
    //             </Row>
    //         </div>
    //     </>
    // );

    let newStatsConfidenceIntervalsRows2 = Object.keys(
        confidenceIntervalsTable
    ).map((key) => {
        let item = confidenceIntervalsTable[key];
        let fixedValue = item.value;

        let cI = ['crit_t_stat', 'avg_interval_lower', 'avg_interval_upper'];

        return (
            <>
                {!cI.includes(key) && (
                    <tr>
                        <td className="title">{item.display_name}</td>
                        <td className="value">{fixedValue}</td>
                    </tr>
                )}
            </>
        );
    });

    let statConfidenceIntervalsTable2 = (
        <>
            <div key="12341">
                <div>
                    <div>
                        <table className="table-cis" style={{ marginTop: 0 }}>
                            <tbody>{newStatsConfidenceIntervalsRows2}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    let newStatsConfidenceIntervalsRows3 = Object.keys(
        confidenceIntervalsTable
    ).map((key) => {
        let item = confidenceIntervalsTable[key];
        let fixedValue = item.value;

        let cI = ['crit_t_stat', 'avg_interval_lower', 'avg_interval_upper'];

        return (
            <>
                {cI.includes(key) && (
                    <tr>
                        <td className="value">{item.display_name}</td>
                        <td className="value">{fixedValue[0]}</td>
                        <td className="value">{fixedValue[1]}</td>
                        <td className="value">{fixedValue[2]}</td>
                        <td className="value">{fixedValue[3]}</td>
                    </tr>
                )}
            </>
        );
    });
    let statConfidenceIntervalsTable3 = (
        <>
            <div key="12341">
                {/* <Row className="statistics-row-box" gutter={16}> */}
                <div>
                    <div>
                        <table className="table-cis second">
                            <thead>
                                <tr>
                                    <th>Confidence Interval</th>
                                    <th>50% </th>
                                    <th>68% </th>
                                    <th>90% </th>
                                    <th>95% </th>
                                </tr>
                            </thead>
                            <tbody>{newStatsConfidenceIntervalsRows3}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    return (
        <>
            {/* <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel key={1} header={`New Confidence Intervals`}> */}
            <HighchartsReact
                highcharts={Highcharts}
                options={confidenceIntervalsOptions}
                ref={props.forwardedRef}
            />

            {/* {statConfidenceIntervalsTable} */}
            {/* {statConfidenceIntervalsTable2}
                    {statConfidenceIntervalsTable3} */}
            {/* </Panel>
            </Collapse> */}
        </>
    );
};

export default React.memo(ConfidenceIntervalsChart);
